<script>
	import { navigate } from "svelte-routing";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";
	import JobsBacklogTable from "./JobsBacklogTable.svelte";
	import JobsBacklogDetails from "./JobsBacklogDetails.svelte";
	import {
		extractErrorMessage,
		splitCamelCaseAndCapitalize,
		daysElapsed,
	} from "src/utils/misc";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import client from "src/services/client";
	import queryString from "query-string";
	import { onMount } from "svelte";
	import ConfirmModal from "../../../components/CustomModal/ConfirmModal.svelte";
	import { canAssign, loading } from "src/store/store";

	export let fetchBacklog;
	export let lookups;
	export let backlogTasks = [];
	export let vehicles = {};
	export let triggerSortBacklog = () => {};
	export let sortDir = 1;

	let openDeleteModal = false;

	$: hasOtherKeys = false;
	$: data = [];

	$: if (backlogTasks.length > 0) {
		data = backlogTasks.map((task) => {
			return {
				backlogTaskId: task.taskId,
				vehicleId: task.vehicleId,
				ReportedBy: task.createdBy,
				"Vehicle No.": vehicles[task.vehicleId].plateNumber,
				"Car Status": vehicles[task.vehicleId].statusId,
				Task: task.presetTaskDescription,
				Priority: task?.priority.toString(),
				Bookings: vehicles[task.vehicleId].bookings,
				Region: splitCamelCaseAndCapitalize(
					vehicles[task.vehicleId].region || "-"
				),
				Estate: vehicles[task.vehicleId].estateName || "-",
				Address: vehicles[task.vehicleId].address,
				"Days Elapsed": daysElapsed(task.createdAt),
				Remarks: task.plannerRemarks,
				Vehicle: `${vehicles[task.vehicleId].color} ${
					vehicles[task.vehicleId].make
				} ${vehicles[task.vehicleId].model}`,
				Actions: {},
			};
		});
	} else {
		setFilterError();
		canAssign.set(false);
		data = [];
		vehicles = {};
	}

	let task = {};
	let checkedTasks = [];
	let query = {};

	$: isOpen = false;
	$: toggleDetails = (idx) => {
		task = data[idx];
		isOpen = !isOpen;
	};

	function setFilterError() {
		query = queryString.parse(window.location.search);
		const allowedValues = ["tab", "pageNumber", "pageSize"];
		hasOtherKeys = Object.keys(query).some(
			(item) => !allowedValues.includes(item)
		);
	}

	async function changeCarStatus(vehicleId, status) {
		try {
			const res = await client(`/v2/${vehicleId}/status`, {
				method: "PUT",
				version: "Vehicle",
				data: {
					statusId: status,
				},
			});
			await fetchBacklog();
			return res;
		} catch (error) {
			console.log(error);
		}
	}

	async function fetchVehicleStatuses() {
		try {
			const res = await client(`/v2/masterDatas/vehicleStatuses`, {
				method: "GET",
				version: "Vehicle",
			});
			if (res.status === 200) {
				lookups.vehicleStatuses = res.data;
			}
		} catch (error) {
			console.log(error);
			extractErrorMessage(error);
		}
	}

	async function changePriority(taskId, priority) {
		try {
			const res = await client(`/v1/tasks/${taskId}/priority`, {
				method: "PUT",
				version: "Tasking",
				data: {
					priority: parseInt(priority),
				},
			});
			if (res.status === 204) {
				fetchBacklog();
			}
		} catch (error) {
			console.log(error);
			extractErrorMessage(error);
		}
	}

	async function deleteTask(taskId) {
		try {
			loading.set(true);
			const res = await client(`/v1/tasks/${taskId}`, {
				method: "DELETE",
				version: "Tasking",
			});
			if (res.status === 204) {
				fetchBacklog();
				toggleDeleteModal();
				loading.set(false);
			}
		} catch (err) {
			console.log(err);
			loading.set(false);
			extractErrorMessage(err);
		}
	}

	function toggleDeleteModal(id) {
		if (!id) {
			openDeleteModal = false;
			return;
		}
		openDeleteModal = id;
	}

	onMount(() => {
		fetchVehicleStatuses();
	});
</script>

<LoaderContainer>
	{#if data.length > 0}
		<JobsBacklogTable
			{checkedTasks}
			{vehicles}
			backlogTasks={data.length
				? data.map(({ Vehicle, ReportedBy, Remarks, ...rest }) => rest)
				: []}
			{toggleDetails}
			{changeCarStatus}
			{changePriority}
			{lookups}
			{toggleDeleteModal}
			{triggerSortBacklog}
			{sortDir}
		/>
		{#if isOpen}
			<JobsBacklogDetails {task} {toggleDetails} {lookups} />
		{/if}
	{:else if data.length === 0 && hasOtherKeys}
		<div
			class="d-flex flex-column justify-content-center align-items-center w-100 py-5 my-5"
		>
			<div class="my-2">
				<b>No results were found.</b>
			</div>
			<div class="my-2">
				<span>Try a different set of filters</span>
			</div>
		</div>
	{:else}
		<div
			class="d-flex flex-column justify-content-center align-items-center w-100 py-5 my-5"
		>
			<div class="my-2">
				<b>You don't have any backlog task</b>
			</div>
			<div class="my-2">
				<span>Create a new task with the button below</span>
			</div>
			<div class="my-2">
				<CustomButton
					buttonText="Create task"
					on:click={() => navigate("/jobs/create-task")}
				/>
			</div>
		</div>
	{/if}
</LoaderContainer>
<ConfirmModal
	open={Boolean(openDeleteModal)}
	toggle={() => toggleDeleteModal()}
	header="Delete Task"
	bodyText="You are about to delete this task. Once you confirm, it will be permanently lost and cannot be recovered. Are you sure you want to proceed?"
	buttonText="Confirm"
	buttonColor="primary"
	outline={false}
	handleSubmit={() => deleteTask(openDeleteModal)}
/>
